import React from "react";
import PropTypes from "prop-types";

const SameCategory = ({ posts, theme }) => {
  const catName = posts.length ? posts[0].node.frontmatter.category : "the same category";

  return (
    <React.Fragment>
      <h3>In {catName}</h3>
      <ul className="categoryList">
        {!!posts &&
          posts.map(({ node: { fields: { slug }, frontmatter: { title } } }) => (
            <li key={slug}>
              <a href={slug}>{title}</a>
            </li>
          ))}
      </ul>

      <style jsx>
        {`
          h3 {
            margin-top: 0;
            margin-bottom: 1rem;
            font-size: 1.1rem;
          }

          ul {
            padding: 10px;
            list-style: circle;
          }

          li {
            padding-bottom: 5px;
          }

          a {
            transition: 0.3s all linear;
            :hover {
              color: ${theme.color.brand.primaryActive};
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

SameCategory.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      node: {
        fields: { slug: PropTypes.string },
        frontmatter: { title: PropTypes.string, category: PropTypes.string }
      }
    })
  ),
  theme: PropTypes.shape({
    color: {
      brand: {
        primary: PropTypes.string,
        primaryActive: PropTypes.string
      }
    }
  })
};

export default SameCategory;
